import { xsmall, small, medium, large, xlarge, fullScreen } from './design-tokens';

export const device = {
    GteXsmall: `only screen and (min-width: ${xsmall})`,
    GteSmall: `only screen and (min-width: ${small})`,
    GteMedium: `only screen and (min-width: ${medium})`,
    GteLarge: `only screen and (min-width: ${large})`,
    GteXLarge: `only screen and (min-width: ${xlarge})`,
    FullScreen: `only screen and (min-width: ${fullScreen})`,
    MinResolution2x: `only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 192dpi)`,
};

export const deviceGte = (screenSize) => {
    return `only screen and (min-width: ${screenSize}px)`;
};
